import * as z from "zod";

export const PaymentTypeNameSchema = z.union([
  z.literal("posBoss"),
  z.string(),
]);
export type PaymentTypeName = z.infer<typeof PaymentTypeNameSchema>;

export const TransactionTypeSchema = z.union([
  z.literal("CREDIT"),
  z.literal("DEBIT"),
  z.literal("REFUND"),
  z.literal("PAYMENT"),
]);
export type TransactionType = z.infer<typeof TransactionTypeSchema>;

export const TransactionSchema = z.object({
  uuid: z.string(),
  createdAt: z.string(),
  taxInclusive: z.coerce.number(),
  taxExclusive: z.coerce.number(),
  taxRate: z.string(),
  taxAmount: z.string(),
  paymentTypeName: PaymentTypeNameSchema,
  transactionType: TransactionTypeSchema,
});
export type Transaction = z.infer<typeof TransactionSchema>;

export const ItemModTypeSchema = z.union([
  z.literal("mandatory"),
  z.literal("optional"),
]);
export type ItemModType = z.infer<typeof ItemModTypeSchema>;
export const OrderItemModSchema = z.object({
  itemModUuid: z.string(),
  name: z.string(),
  itemModGroupUuid: z.string(),
  salesPriceUuid: z.string(),
  itemModType: z.union([z.literal("mandatory"), z.literal("optional")]),
  salesPriceTaxInclusive: z.coerce.number(),
});
export type OrderItemMod = z.infer<typeof OrderItemModSchema>;

export const OrderItemSchema = z.object({
  uuid: z.string().toLowerCase(),
  totalSalesPriceTaxInclusive: z.coerce.number(),
  salesPriceUuid: z.string(),
  itemName: z.string(),
  multiplier: z.coerce.number(),
  itemUuid: z.string(),
  orderItemMods: z.array(OrderItemModSchema),
  itemHeroImageUrl: z.string().nullable(),
  itemHeroImageThumbnailUrl: z.string().nullable(),
  paymentUuid: z.string().nullable(),
  refundUuid: z.string().nullable(),
  voided: z.coerce.boolean(),
});
export type OrderItem = z.infer<typeof OrderItemSchema>;

export const OrderSchema = z.object({
  uuid: z.string().toLowerCase(),
  createdAt: z.string(),
  orderNumber: z.coerce.string().nullable(),
  orderItems: z.array(OrderItemSchema),
});
export type Order = z.infer<typeof OrderSchema>;

export const CustomerTabSchema = z.object({
  uuid: z.string(),
  createdAt: z.string().optional(),
  name: z.string(),
  closedAt: z.string().nullish(),
  totalHolidaySurcharges: z.array(z.any()),
  tableName: z.string().nullish(),
  tableUuid: z.string().nullish(),
  orders: z.array(OrderSchema),
  transactions: z.array(TransactionSchema),
});
export type CustomerTab = z.infer<typeof CustomerTabSchema>;
